export const API_BASE_URL = 'https://5opajqsdjd.execute-api.us-east-2.amazonaws.com/prod';

export const API_ENDPOINTS = {
  // Token Query Page APIs
  checkCA: `${API_BASE_URL}/check-ca-fallback`,
  checkCAFallback: `${API_BASE_URL}/check-ca-fallback`,
  tokenInfo: `${API_BASE_URL}/get-token-info-fallback`,
  tokenInfoFallback: `${API_BASE_URL}/get-token-info-fallback`,
  xSensation: `${API_BASE_URL}/x-sensation`,
  checkRugWallet: `${API_BASE_URL}/check-rug-wallet`,
  mindshare: `${API_BASE_URL}/get-mindshare`,
  tgMetrics: `${API_BASE_URL}/tg-metrics`,
  trenchRadar: `${API_BASE_URL}/trench-radar`,
  repoAnalyzer: `https://lb.repoanalyzer.io/repository/analyze`,
  // View Management
  createView: `${API_BASE_URL}/db-view`,
  viewHistory: `${API_BASE_URL}/db-view/history`,
  // Report Rugger Page
  reportRugger: `${API_BASE_URL}/report-rugger`,
  // Chrome extension token auth is a NextJS API route
  createExtensionToken: `/api/create-extension-token`,
  // User Management
  user: `${API_BASE_URL}/db-user`,
  // Credit APIs
  grantCredits: `${API_BASE_URL}/db-credit/grant`,
  creditBalance: `${API_BASE_URL}/db-credit/balance`,
} as const;

export const LINKS = {
  helio: 'https://helio.fun',
  repoAnalyzer: 'https://repoanalyzer.io',
  trenchRadar: 'https://trench.bot',
};
